<template>
  <div class="app-wrapper" id="app">
    <router-view class="view"></router-view>
  </div>
</template>

<script>
import {emptyData} from './store.js';

export default {
  name: 'app',
  components: {

  },
  beforeCreate: function() {
    if(!this.$store.getters.getState) {
      this.$store.dispatch('addState', emptyData);
    }
  },
  computed: {
    getState() {
      return this.$store.getters.getState;
    }
  },
};
</script>

<style>
#app {
  min-width: 320px;
}
</style>
